import { render, staticRenderFns } from "./AdsCarousel.vue?vue&type=template&id=2bbf5566&scoped=true&"
import script from "./AdsCarousel.vue?vue&type=script&lang=js&"
export * from "./AdsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AdsCarousel.vue?vue&type=style&index=0&id=2bbf5566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf5566",
  null
  
)

export default component.exports